var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.booking.is_offer
    ? _c(
        "div",
        { staticClass: "dashboard-block" },
        [
          _c("h2", [
            _vm._v("\n    Manager Notifications\n\n    "),
            _vm.userCanNotifyManagers
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-sm pull-right",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#modal-notify-managers",
                      "data-backdrop": "static",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" "),
                    _vm.$userIsAdmin ? [_vm._v("Notify Managers")] : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.haveNoManagersNotified
            ? _c("div", { staticClass: "text-center alert alert-default" }, [
                _vm._v("\n    There are no notified managers.\n  "),
              ])
            : _c(
                "ul",
                { staticClass: "tags" },
                _vm._l(_vm.booking.managers_notified, function (manager) {
                  return _c("li", { key: manager.id }, [
                    _c("span", [_vm._v(_vm._s(manager.name))]),
                  ])
                }),
                0
              ),
          _vm._v(" "),
          _vm.$userIsAdmin ? _c("booking-notify-managers-modal") : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }